/** Token opaco retornado/enviado pela API Clientes; não é ID numérico. */
export type TranscricaoResourceToken = string;

export const resolveTranscricaoResourceToken = (
  raw?: string | number | null,
): TranscricaoResourceToken | null => {
  if (raw === null || raw === undefined) return null;
  const text = String(raw).trim();
  return text || null;
};

export const buildTranscricaoConsultaPath = (token: TranscricaoResourceToken): string =>
  `/guiasEautorizacoes/transcricaoSolicitacao/consultar/${encodeURIComponent(token)}`;

export const buildResolverPendenciaPath = (token: TranscricaoResourceToken): string =>
  `${buildTranscricaoConsultaPath(token)}/resolverPendencia`;
